// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductQuantityOrderedStyles } from "@adl/Overrides/Components/ProductQuantityOrdered";
import { color } from "@adl/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface ProductDetailsCartActionsStyle {
    addToCartContainer?: GridContainerProps;
    qtyWrapper?: GridItemProps;
    productQuantityOrderedStyles?: ProductQuantityOrderedStyles;
    addToCartButtonWrapper?: GridItemProps;
    productAddToCartButtonStyles?: ButtonPresentationProps;
}

const styles: ProductDetailsCartActionsStyle = {
    addToCartContainer: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
        `,
    },
    qtyWrapper: {
        css: css`
            margin-right: 16px;
        `,
    },
    productQuantityOrderedStyles: {
        mergeCss: true,
        cssOverrides: {
            formField: css`
                margin-top: 0;
            `,
            inputSelect: css`
                text-align: center;
                color: ${color("text")};
            `,
        },
        actionsStyles: {
            quantityOrderedTextField: {
                sizeVariant: "small",
                cssOverrides: {
                    inputSelect: css`
                        height: 28px;
                    `,
                },
            },
        },
    },
    addToCartButtonWrapper: {
        css: css`
            flex-grow: 1;
            & > button {
                width: 100%;
            }
        `,
    },
    productAddToCartButtonStyles: {
        mergeCss: true,
        sizeVariant: "small",
        css: css`
            width: 100%;
        `,
    },
};

const ProductDetailsCartActions: FC<Props> = () => {
    return (
        <StyledWrapper {...styles.addToCartContainer} data-test-selector="productDetails_cart_actions">
            <StyledWrapper {...styles.qtyWrapper}>
                {createWidgetElement("ProductDetails/ProductDetailsQuantityOrdered", { fields: {} })}
            </StyledWrapper>
            <StyledWrapper {...styles.addToCartButtonWrapper}>
                {createWidgetElement("ProductDetails/ProductDetailsAddToCartButton", { fields: {} })}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsCartActions,
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
